<template>
  <div class="privacy-policy-page">
    <!-- 顶部导航栏 -->
  <header class="sticky top-0 z-50 bg-white bg-opacity-90 backdrop-blur shadow-sm py-4 h-24">
    <div class="container mx-auto px-10">
      <div class="flex justify-between items-center">
        <div class="cursor-pointer">
         <router-link to="/" >
         	<img src="../assets/logo.png" width="164px" height="60px" />
         </router-link>
        </div>
        <nav class="hidden md:flex gap-8 text-sm text-gray-600">
         <router-link to="/banking"  class="nav-link">Banking</router-link>
         <router-link to="/exchange"  class="nav-link">Exchange</router-link>
         <router-link to="/issuing"  class="nav-link">Issuing</router-link>
         <router-link to="/acquiring"  class="nav-link">Acquiring</router-link>
         <router-link to="/company"  class="nav-link">Company</router-link>
        </nav>
        <button class="bg-primaryBlue text-white px-5 py-2 rounded-full text-sm font-medium hover:bg-primaryBlueDark transition-colors" @click="scrollToWithOffset('4700')">
          Get Started
        </button>
      </div>
    </div>
  </header>

 <main class="container mx-auto px-4 max-w-[1280px] py-10">
    <h1 class="text-[42px] font-bold text-[] text-center mb-10" style="color:#1F72D8;font-size: font-size: 3rem;">Terms & Conditions</h1>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-10 mt-12">
      <!-- 左侧 -->
      <div>
        <section class="border border-white bg-[#F5F9FF] rounded-lg p-5 mb-8 text-left" style="background:#F5F9FF;">
          <h2 class="text-[24px] font-semibold text-gray-900 mb-4 leading-relaxed">A Legal Disclaimer</h2>
          <p class="text-sm text-gray-600 leading-relaxed mb-3">
            The explanations and information provided on this page are only general and high-level explanations and information on how to write your own document of Terms & Conditions. You should not rely on this article as legal advice or as recommendations regarding what you should actually do, because we cannot know in advance what are the specific terms you wish to establish between your business and your customers and visitors. We recommend that you seek legal advice to help you understand and to assist you in the creation of your own terms Terms & Conditions.
          </p>
        </section>

        <section class="border border-white bg-[#F5F9FF] rounded-lg p-5 text-left" style="background:#F5F9FF;">
          <h2 class="text-[24px] font-semibold text-gray-900 mb-4 leading-relaxed">What to Include in the T&C Document</h2>
          <p class="text-sm text-gray-600 leading-relaxed mb-3">
            Generally speaking, T&C often address these types of issues: Who is allowed to use the website; the possible payment methods; a declaration that the website owner may change his or her offering in the future; the types of warranties the website owner gives her or his customers; a reference to issues of intellectual property or copyrights, where relevant; the website owner’s right to suspend or cancel a member’s account; and much, much more.
          </p>
          <p class="text-sm text-gray-600 leading-relaxed">
            To learn more about this, check out our article “Creating a Terms and Conditions Policy”.
          </p>
        </section>
      </div>

      <!-- 右侧 -->
      <div>
        <section class="border border-white bg-[#F5F9FF] rounded-lg p-5 h-full text-leftss" style="background:#F5F9FF;">
          <h2 class="text-[24px] font-semibold text-gray-900 mb-4 leading-relaxed">Terms & Conditions - The Basics</h2>
          <p class="text-sm text-gray-600 leading-relaxed mb-3">
            Having said that, Terms and Conditions (“T&C”) are a set of legally binding terms defined by you, as the owner of this website. The T&C set forth the legal boundaries governing the activities of the website visitors, or your customers, while they visit or engage with this website. The T&C are meant to establish the legal relationship between the site visitors and you as the website owner.
          </p>
          <p class="text-sm text-gray-600 leading-relaxed mb-3">
            T&C should be defined according to the specific needs and nature of each website. For example, a website offering products to customers in e-commerce transactions requires T&C that are different from the T&C of a website only providing information (like a blog, a landing page, and so on).
          </p>
          <p class="text-sm text-gray-600 leading-relaxed">
            T&C provide you as the website owner the ability to protect yourself from potential legal exposure, but this may differ from jurisdiction to jurisdiction, so make sure to receive local legal advice if you are trying to protect yourself from legal exposure.
          </p>
        </section>
      </div>
    </div>
  </main>

	
	<!-- 页脚 全部居中 -->
	  <footer class="text-white pt-16" style="background:#003372 ;">
	    <div class="max-w-[1280px] mx-auto px-10 grid grid-cols-1 md:grid-cols-2 gap-8">
	      <!-- 左侧区域 -->
	      <div class="flex flex-col gap-6">
	        <!-- Logo -->
	        <div class="mb-6">
	          <img src="../assets/logo-withe.png" alt="UNIPAY Logo" class="h-[50px] w-auto">
	        </div>
	
	        <!-- 导航 + 联系信息 行 -->
	        <div class="flex flex-wrap gap-8 md:gap-[80px]">
	          <!-- 第一列 -->
	          <div class="flex flex-col gap-5 text-left">
	            <router-link to="/" class="text-white text-base hover:text-gray-300">Home</router-link>
	            <router-link to="/banking" class="text-white text-base hover:text-gray-300">Banking</router-link>
	            <router-link to="/exchange" class="text-white text-base hover:text-gray-300">Exchange</router-link>
	            <router-link to="/acquiring" class="text-white text-base hover:text-gray-300">Acquiring</router-link>
	          </div>
	
	          <!-- 第二列 -->
	          <div class="flex flex-col gap-5 text-left">
	            <router-link to="/issuing" class="text-white text-base hover:text-gray-300">Issuing</router-link>
	            <router-link to="/company" class="text-white text-base hover:text-gray-300">Company</router-link>
	          </div>
	
	          <!-- 联系信息 -->
	          <div class="flex flex-col gap-5 text-left">
	            <div class="flex items-start gap-2">
	              <span class="text-lg">✉️</span>
	              <div>
	                <div class="text-white text-base">Email:</div>
	                <div class="text-white text-base">operation@unipay-global.com</div>
	              </div>
	            </div>
	            <div class="flex items-start gap-2">
	              <span class="text-lg">📍</span>
	              <div>
	                <div class="text-white text-base">Address:</div>
	                <div class="text-white text-base">Bleichistrasse 8, 6300 Zug,</div>
	                <div class="text-white text-base">Switzerland.</div>
	              </div>
	            </div>
	          </div>
	        </div>
	
	        <!-- 标语 -->
	        <div class="border-t border-white/20 pt-5 mt-2 text-lg text-left">
	          <p class="py-1">Professional, Intelligent Global Fund Management Partner</p>
	          <p class="py-1">Ready to streamline your global operations?</p>
	        </div>
	
	        <!-- 底部链接 -->
	        <div class="pt-4 flex gap-6">
	          <router-link to="/policy" class="text-white text-sm hover:underline">Privacy Policy</router-link>
	          <router-link to="/terms" class="text-white text-sm hover:underline">Terms & Conditions</router-link>
	        </div>
	      </div>
	
	      <!-- 右侧表单区域 -->
	      <div class="flex flex-col gap-6">
	        <h2 class="text-xl font-bold">Contact Us</h2>
	        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
	          <div class="form-group">
	            <label class="block text-sm mb-2">First name *</label>
	            <input type="text" v-model="firstName" required
	              class="w-full p-3 bg-transparent border border-white rounded-none text-white placeholder-white/70">
	          </div>
	          <div class="form-group">
	            <label class="block text-sm mb-2">Last name *</label>
	            <input type="text" v-model="lastName" required
	              class="w-full p-3 bg-transparent border border-white rounded-none text-white placeholder-white/70">
	          </div>
	          <div class="form-group">
	            <label class="block text-sm mb-2">Email *</label>
	            <input type="email" v-model="email" required
	              class="w-full p-3 bg-transparent border border-white rounded-none text-white placeholder-white/70">
	          </div>
	          <div class="form-group">
	            <label class="block text-sm mb-2">Phone *</label>
	            <input type="tel" v-model="phone"
	              class="w-full p-3 bg-transparent border border-white rounded-none text-white placeholder-white/70">
	          </div>
	          <div class="md:col-span-2">
	            <label class="block text-sm mb-2">Message *</label>
	            <textarea v-model="message" required rows="4"
	              class="w-full p-3 bg-transparent border border-white rounded-none text-white placeholder-white/70"></textarea>
	          </div>
	          <button id="submit-btn" @click="sendMsg"
	            class="md:col-span-2 bg-blue-600 hover:bg-blue-700 text-white py-3 font-medium transition-colors">
	            提交您的信息
	          </button>
	        </div>
	      </div>
	    </div>
	
	    <!-- 版权信息 -->
	    <div class="max-w-[1280px] mx-auto px-4 text-center py-6 mt-8 text-white text-sm border-t border-white/10">
	      <p>Copyright © 2025 UNIPAY GLOBAL. All rights reserved.</p>
	    </div>
	  </footer>
	
	  <div class="flex justify-center">
	    <IpAlert :visible="showAlert" :content="alertContent" @close="showAlert = false" />
	  </div>
</div>
</template>


<style scoped>
			.privacy-policy-page{
			 background:#EBF3FF;
			}
</style>
<script setup>
	import axios from 'axios';
	import { ref } from 'vue';
	import IpAlert from "./IpAlert.vue"; // 引入弹窗组件
	// import { useRouter } from 'vue-router';
	
	// const router = useRouter();
    const firstName = ref('');
	const lastName = ref('');
	const phone = ref('');
	const email = ref('');
	const message = ref('');
	// 响应式变量：控制弹窗显示/隐藏
	const showAlert= ref(false);
    const alertContent =ref('');
	
	function scrollToWithOffset(top) {
	    window.scrollTo({ top, behavior: 'smooth' });
	}
	
	function sendMsg(){
		if(firstName.value  == ''){
			showAlert.value="true";
			alertContent.value="First name is null";
			return false;
		}
		if(lastName.value  == ''){
			showAlert.value="true";
			alertContent.value="Last name is null";
			return false;
		}
		if(!checkEmail(email.value)){
			showAlert.value="true";
			alertContent.value="email is error";
			return false;
		}
		if(phone.value  == ''){
			showAlert.value="true";
			alertContent.value="phone is null";
			return false;
		}
		if(message.value  == ''){
			showAlert.value="true";
			alertContent.value="message is null";
			return false;
		}
		axios.post('/api/email', {
		    firstName: firstName.value,        
		    lastName: lastName.value,
			phone:phone.value,
			email:email.value,  
			message:message.value
		  })
		  .then(function (response) {
			  const data =response.data;
			  if(data.code =='000'){
				  const btnByClass = document.getElementById('submit-btn');
				  btnByClass.disabled = true;
				  showAlert.value =true;
		          alertContent.value="Thank you for subscribing! You will now receive our latest updates. ";
			  }
		  })
		  .catch(function (error) {
		    console.log(error);
		  });
	}
	
	function checkEmail(email) {
	    // 空值/非字符串处理
	    if (!email || typeof email !== 'string') return false;
	    // 主流邮箱正则：支持字母/数字/下划线/点/减号 + @ + 域名 + 顶级域名(2-6位)
	    const emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
	    return emailReg.test(email.trim());
	}
	
	
</script>